import { ControllerChat } from "./ChatImplementations/ControllerChat/ControllerChat";
import { FamillyChat } from "./ChatImplementations/FamillyChat/FamillyChat";
import { GptChat } from "./ChatImplementations/GptChat/GptChat";
import { ChatType, IChatImplementation, IChatService } from "./IChatService";

export class ChatService implements IChatService {
    public static readonly ServiceName: string = "ChatService";

    private _services: Record<string, IChatImplementation> = {
        ControllerChat: new ControllerChat(),
        GptChat: new GptChat(),
        FamillyChat: new FamillyChat(),
    }

    GetServiceName(): string {
        return ChatService.ServiceName;
    }

    GetChatImplementation<T extends IChatImplementation>(chatType: ChatType): T {
        switch(chatType){
            case ChatType.ControllerChat:
                return this._services.ControllerChat as unknown as T;
            case ChatType.FamilyChat:
                return this._services.FamillyChat as unknown as T;
            case ChatType.GptChat:
                return this._services.GptChat as unknown as T;
            default:
                throw new ChatNotImplementedException(`Chat with type ${chatType} not implemented!`);

        }
    }
}

export enum ChatServiceErrorCode {
    OtherError = "OtherError",
    FatalError = "FatalError",
    Error = "Error",
    NoData = "NoData",
}

class ChatNotImplementedException extends Error {
    constructor(public message: string) {
        super(message);
        this.name = "ChatNotImplementedException";
    }
}